import { uiBus } from 'shared/api/uiBus';

function normalizeLine(value) {
  if (!value) return null;
  if (typeof value === 'string') {
    const line = value.trim();
    return line || null;
  }
  if (typeof value === 'object') {
    const line = value.message || value.error || value.msg || value.code;
    return normalizeLine(line);
  }
  return normalizeLine(String(value));
}

function collectLines(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.map(normalizeLine).filter(Boolean);
  return [normalizeLine(value)].filter(Boolean);
}

export function extractApiError(error, fallback = 'Islem sirasinda bir hata olustu.') {
  const data = error?.data || error?.response?.data || null;
  const status = error?.status || error?.response?.status || data?.status || 0;
  const code = data?.code || error?.code || 'ERROR';
  const baseMessage =
    normalizeLine(data?.message) ||
    normalizeLine(data?.error) ||
    normalizeLine(error?.message) ||
    fallback;

  const details = [
    ...collectLines(data?.warnings),
    ...collectLines(data?.blocks),
    ...collectLines(data?.errors),
    ...collectLines(data?.details),
    ...collectLines(data?.fieldErrors),
  ].filter(Boolean);

  const uniqueDetails = Array.from(new Set(details.filter((line) => line !== baseMessage)));

  return {
    status,
    code,
    requestId: data?.requestId || error?.requestId || null,
    message: baseMessage,
    details: uniqueDetails,
    messages: [baseMessage, ...uniqueDetails],
    raw: data || error || null,
  };
}

export function formatApiError(error, fallback) {
  const apiError = extractApiError(error, fallback);
  return apiError.messages.join('\n');
}

export function toastError(error, fallback = 'Islem basarisiz.') {
  const apiError = extractApiError(error, fallback);
  uiBus.emit('toast', { type: 'error', message: apiError.message });
  return apiError;
}
